// Назначение роли и замещение (contracts/api.md, «Назначения ролей и замещения»).
import { z } from '../kernel/zod.ts';
import {
  DateSchema,
  IdSchema,
  PersonRefSchema,
  TimestampSchema,
  VersionSchema,
} from '../kernel/common.ts';
import { RoleSchema } from '../rights/roles.ts';
import { AreaSchema } from './area.ts';

export const AssignmentSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  role: RoleSchema,
  /** У замещения — области исходного назначения. */
  areas: z.array(AreaSchema),
  /** Пусто — без ограничения. */
  validFrom: DateSchema.optional(),
  validTo: DateSchema.optional(),
  /** Заполнено — это замещение. */
  substitutesAssignmentId: IdSchema.optional(),
  version: VersionSchema,
  archivedAt: TimestampSchema.optional(),
});
export type Assignment = z.infer<typeof AssignmentSchema>;

/** Вычисляется по датам и отмене; закончилось — после конца дня validTo в поясе установки. */
export const substitutionStates = ['planned', 'active', 'ended', 'cancelled'] as const;
export const SubstitutionStateSchema = z.enum(substitutionStates);
export type SubstitutionState = (typeof substitutionStates)[number];

/**
 * Замещение — назначение с заполненным substitutesAssignmentId и вычисленным state.
 * userId — заместитель. owner и deputy — чтобы строку списка мог показать и не администратор.
 * createdAt и createdBy — когда и кто передал роль: администратор или владелец роли (карточка
 * замещения, T133); createdBy нет у записи без автора.
 */
export const SubstitutionSchema = AssignmentSchema.extend({
  substitutesAssignmentId: IdSchema,
  validFrom: DateSchema,
  validTo: DateSchema,
  state: SubstitutionStateSchema,
  owner: PersonRefSchema,
  deputy: PersonRefSchema,
  createdAt: TimestampSchema,
  createdBy: PersonRefSchema.optional(),
});
export type Substitution = z.infer<typeof SubstitutionSchema>;
